module.exports = __webpack_public_path__ + "img/26.de33a16b.png";